<div class="container-fluid vh-100 w-100">
  <div class="row">
    <div class="col-md-12 sup-line p-10 w-100" style="padding-top: 15px;">
      <div class="col-md-1 float-end">
        <!-- <app-navbar></app-navbar> -->
      </div>
    </div>

    <div class="text-center col-md-12 mb-2 mt-1">
      <img alt="" height="49" width="154" src="./assets/images/logo-10anos.png">
    </div>

    <div class="col-md-12 bot-line w-100 p-3">
      <app-navbar></app-navbar>
    </div>
  </div>

  <router-outlet></router-outlet>
  
</div>